import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const Icon = ({ icon, title, ...rest }) => {
  const faIcon = Array.isArray(icon) ? icon : ['far', icon]

  if (title) {
    return (
      <span title={title}>
        <FontAwesomeIcon icon={faIcon} {...rest} />
      </span>
    )
  }

  return <FontAwesomeIcon icon={faIcon} {...rest} />
}

export default Icon
